'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';

const STEPS = [
    { icon: 'pi pi-upload',     label: 'Upload Invoice',  desc: 'Amazon or Flipkart PDF' },
    { icon: 'pi pi-search',     label: 'Auto Scan',       desc: 'We read your order' },
    { icon: 'pi pi-shield',     label: 'View Status',     desc: 'Instant result' },
];

export const WarrantySection = () => {
    const router  = useRouter();
    const [hovered, setHovered] = useState(false);

    return (
        <section className="container" style={{ padding: '2.5rem 1rem 3rem' }}>
            <style>{`
                @keyframes wc-scan {
                    0%   { top: 0%;   opacity: 0; }
                    5%   { opacity: 1; }
                    95%  { opacity: 0.6; }
                    100% { top: 100%; opacity: 0; }
                }
                @keyframes wc-float {
                    0%, 100% { transform: translateY(0)    rotate(0deg);  opacity: 0.05; }
                    50%      { transform: translateY(-14px) rotate(6deg); opacity: 0.1; }
                }
                @keyframes wc-glow-breathe {
                    0%, 100% { opacity: 0.8; transform: scale(1); }
                    50%      { opacity: 1;   transform: scale(1.08); }
                }
                @keyframes wc-shimmer {
                    0%   { left: -60%; }
                    100% { left: 120%; }
                }
                .wc-card {
                    position: relative;
                    overflow: hidden;
                    border-radius: 1.25rem;
                    background: linear-gradient(135deg, #0c3264 0%, #0a2a5e 60%, #0e4a5c 100%);
                    box-shadow: 0 12px 48px rgba(12,50,100,0.35);
                    padding: 2.5rem 2.25rem;
                }
                .wc-card::after {
                    content: '';
                    position: absolute; top: 0; left: -60%; width: 40%; height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.04), transparent);
                    animation: wc-shimmer 4s ease-in-out 2s infinite;
                    pointer-events: none;
                }
                .wc-scan-line {
                    position: absolute; left: 0; right: 0; height: 1.5px;
                    background: linear-gradient(90deg, transparent 0%, rgba(0,210,190,0.6) 30%, rgba(0,210,190,0.9) 50%, rgba(0,210,190,0.6) 70%, transparent 100%);
                    animation: wc-scan 3.5s ease-in-out 1s infinite;
                    pointer-events: none; z-index: 1;
                }
                .wc-glow-1 {
                    position: absolute; top: -80px; right: -80px;
                    width: 280px; height: 280px; border-radius: 50%;
                    background: radial-gradient(circle, rgba(0,210,190,0.15) 0%, transparent 70%);
                    pointer-events: none;
                    animation: wc-glow-breathe 5s ease-in-out infinite;
                }
                .wc-glow-2 {
                    position: absolute; bottom: -60px; left: 30%;
                    width: 220px; height: 220px; border-radius: 50%;
                    background: radial-gradient(circle, rgba(56,189,248,0.08) 0%, transparent 70%);
                    pointer-events: none;
                    animation: wc-glow-breathe 7s ease-in-out 2s infinite;
                }
                .wc-top-row {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    gap: 1.5rem;
                    margin-bottom: 2rem;
                    flex-wrap: wrap;
                }
                .wc-steps {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 0.875rem;
                    margin-bottom: 2rem;
                }
                .wc-bottom-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 1.25rem;
                    flex-wrap: wrap;
                }
                .wc-upload-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 0.55rem;
                    background: #fff;
                    color: var(--primary-color);
                    border: none;
                    border-radius: 0.75rem;
                    padding: 0.8rem 2rem;
                    font-size: 0.92rem;
                    font-weight: 800;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: all 0.22s ease;
                    box-shadow: 0 4px 18px rgba(0,0,0,0.18);
                }
                .wc-upload-btn:hover {
                    background: #f0f5ff;
                    box-shadow: 0 8px 28px rgba(0,0,0,0.25);
                    transform: translateY(-2px);
                }
                .wc-trust-tags {
                    display: flex;
                    gap: 0.75rem;
                    flex-wrap: wrap;
                    align-items: center;
                }
                @media (max-width: 640px) {
                    .wc-card { padding: 1.5rem 1.25rem; }
                    .wc-steps { grid-template-columns: 1fr; gap: 0.6rem; }
                    .wc-bottom-row { flex-direction: column; align-items: stretch; }
                    .wc-upload-btn { width: 100%; justify-content: center; }
                    .wc-trust-tags { justify-content: center; }
                }
            `}</style>

            <div className="wc-card">
                <div className="wc-glow-1" />
                <div className="wc-glow-2" />
                <div className="wc-scan-line" />

                {/* Floating warranty icons */}
                {[
                    { icon: 'pi pi-shield',       top: '15%',  left: '2%',   size: '1.4rem', dur: '8s',  delay: '0s'   },
                    { icon: 'pi pi-file-pdf',     top: '60%',  left: '1.5%', size: '1rem',   dur: '10s', delay: '1.5s' },
                    { icon: 'pi pi-verified',     top: '20%',  right: '2%',  size: '1.1rem', dur: '9s',  delay: '0.8s' },
                    { icon: 'pi pi-check-circle', top: '65%',  right: '3%',  size: '0.9rem', dur: '7s',  delay: '2.5s' },
                    { icon: 'pi pi-calendar',     top: '80%',  left: '20%',  size: '0.85rem',dur: '11s', delay: '1s'   },
                ].map(({ icon, top, left, right, size, dur, delay }) => (
                    <div key={icon + top} style={{ position: 'absolute', top, left, right, pointerEvents: 'none', animation: `wc-float ${dur} ease-in-out ${delay} infinite` }}>
                        <i className={icon} style={{ fontSize: size, color: 'rgba(255,255,255,0.12)' }} />
                    </div>
                ))}

                {/* ── Top row ── */}
                <div className="wc-top-row">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1.1rem' }}>
                        <div style={{
                            width: 60, height: 60, borderRadius: '1rem', flexShrink: 0,
                            background: 'rgba(0,210,190,0.15)',
                            border: '1.5px solid rgba(0,210,190,0.3)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <i className="pi pi-shield" style={{ fontSize: '1.6rem', color: '#00d2be' }} />
                        </div>
                        <div>
                            <h2 style={{ margin: 0, fontSize: 'clamp(1.2rem, 2.5vw, 1.55rem)', fontWeight: 800, color: '#fff', lineHeight: 1.2 }}>
                                Check Your Warranty
                            </h2>
                            <p style={{ margin: '5px 0 0', fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.55, maxWidth: 400 }}>
                                Upload your Amazon or Flipkart invoice PDF and get instant warranty status for all Ennix products in the order.
                            </p>
                        </div>
                    </div>

                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 5, flexShrink: 0,
                        background: 'rgba(0,210,190,0.12)',
                        border: '1px solid rgba(0,210,190,0.3)',
                        color: '#00d2be',
                        borderRadius: 999, padding: '0.3rem 0.9rem',
                        fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase',
                    }}>
                        <i className="pi pi-bolt" style={{ fontSize: '0.6rem' }} />
                        Free &amp; Instant
                    </span>
                </div>

                {/* ── Steps ── */}
                <div className="wc-steps">
                    {STEPS.map(({ icon, label, desc }, i) => (
                        <div key={label} style={{
                            background: 'rgba(255,255,255,0.05)',
                            border: '1px solid rgba(255,255,255,0.08)',
                            borderRadius: '0.875rem',
                            padding: '1rem 1.1rem',
                            display: 'flex', alignItems: 'center', gap: '0.875rem',
                            position: 'relative',
                        }}>
                            <div style={{
                                width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
                                background: 'rgba(0,210,190,0.12)',
                                border: '1px solid rgba(0,210,190,0.25)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <i className={icon} style={{ fontSize: '0.9rem', color: '#00d2be' }} />
                            </div>
                            <div>
                                <div style={{ fontSize: '0.65rem', color: '#00d2be', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 2 }}>
                                    Step {i + 1}
                                </div>
                                <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#fff' }}>{label}</div>
                                <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.5)', marginTop: 1 }}>{desc}</div>
                            </div>

                            {i < STEPS.length - 1 && (
                                <i className="pi pi-arrow-right" style={{
                                    position: 'absolute', right: '-0.55rem',
                                    fontSize: '0.7rem', color: 'rgba(0,210,190,0.4)',
                                    zIndex: 1,
                                }} />
                            )}
                        </div>
                    ))}
                </div>

                {/* ── Bottom ── */}
                <div className="wc-bottom-row">
                    <button
                        className="wc-upload-btn"
                        onClick={() => router.push('/warranty-support')}
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                    >
                        <i className="pi pi-upload" style={{ fontSize: '0.88rem' }} />
                        Upload Invoice
                        <i className="pi pi-arrow-right" style={{
                            fontSize: '0.72rem',
                            transform: hovered ? 'translateX(3px)' : 'translateX(0)',
                            transition: 'transform 0.2s',
                        }} />
                    </button>

                    <div className="wc-trust-tags">
                        {[
                            { icon: 'pi pi-lock',       text: 'Secure upload' },
                            { icon: 'pi pi-user-minus', text: 'No account needed' },
                            { icon: 'pi pi-file-pdf',   text: 'PDF supported' },
                        ].map(({ icon, text }) => (
                            <span key={text} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)' }}>
                                <i className={icon} style={{ fontSize: '0.65rem', color: 'rgba(0,210,190,0.6)' }} />
                                {text}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
